import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AdminRequestService, UserRequest } from 'app/services/adminrequest/adminrequest.service';

@Component({
  selector: 'app-admin-requests',
  templateUrl: './admin-requests.component.html',
  styleUrls: ['./admin-requests.component.scss']
})
export class AdminRequestsComponent implements OnInit {
  pendingRequests: UserRequest[] = [];
  allRequests: UserRequest[] = [];
  activeTab: 'pending' | 'all' = 'pending';
  loading = false;
  error = '';

  stats: any = null;
  loadingStats = false;

  showDetailModal = false;
  selectedRequest: UserRequest | null = null;
  showRejectModal = false;
  selectedRequestId: number | null = null;
  rejectComment = '';

  constructor(private adminRequestService: AdminRequestService,
     private router: Router,
  ) {}

  ngOnInit(): void {
    this.loadRequests();
    this.loadStats();
    this.adminRequestService.refreshNeeded$.subscribe(() => {
      this.loadRequests();
      this.loadStats();
    });
  }

  loadStats(): void {
    this.loadingStats = true;
    this.adminRequestService.getStats().subscribe({
      next: (data) => { this.stats = data; this.loadingStats = false; },
      error: (err) => { console.error(err); this.loadingStats = false; }
    });
  }

  loadRequests(): void {
    this.loading = true;
    this.error = '';
    if (this.activeTab === 'pending') {
      this.adminRequestService.getPendingRequests().subscribe({
        next: (data) => { this.pendingRequests = data; this.loading = false; },
        error: (err) => { this.error = err.message; this.loading = false; }
      });
    } else {
      this.adminRequestService.getAllRequests().subscribe({
        next: (data) => { this.allRequests = data; this.loading = false; },
        error: (err) => { this.error = err.message; this.loading = false; }
      });
    }
  }

  setTab(tab: 'pending' | 'all'): void {
    this.activeTab = tab;
    this.loadRequests();
  }

  viewDetails(request: UserRequest): void {
    this.selectedRequest = request;
    this.showDetailModal = true;
    if (!request.viewedByAdmin) {
      this.adminRequestService.markAsRead(request.id).subscribe();
      request.viewedByAdmin = true;
    }
  }

  closeDetailModal(): void {
    this.showDetailModal = false;
    this.selectedRequest = null;
  }

  approveRequest(id: number): void {
    if (confirm('Approuver cette demande ?')) {
      this.adminRequestService.approveRequest(id).subscribe({
        next: () => this.loadRequests()
      });
    }
  }

  openRejectModal(id: number): void {
    this.selectedRequestId = id;
    this.rejectComment = '';
    this.showRejectModal = true;
  }

  confirmReject(): void {
    if (!this.rejectComment.trim()) {
      alert('Veuillez fournir un commentaire pour le rejet.');
      return;
    }
    if (this.selectedRequestId) {
      this.adminRequestService.rejectRequest(this.selectedRequestId, this.rejectComment).subscribe({
        next: () => {
          this.showRejectModal = false;
          this.loadRequests();
        },
        error: (err) => console.error(err)
      });
    }
  }

  deleteRequest(id: number): void {
    if (confirm('Supprimer définitivement cette demande ?')) {
      this.adminRequestService.deleteRequest(id).subscribe({
        next: () => this.loadRequests()
      });
    }
  }

  getStatusBadgeClass(status: string): string {
    switch (status) {
      case 'APPROUVE': return 'badge-success';
      case 'REFUSE': return 'badge-danger';
      default: return 'badge-warning';
    }
  }

  getOperationLabel(operation: string): string {
    switch(operation) {
      case 'AJOUT': return '➕ Ajout';
      case 'MODIFICATION': return '✏️ Modification';
      case 'SUPPRESSION': return '🗑️ Suppression';
      default: return operation;
    }
  }
  goToDetail(requestId: number): void {
  this.router.navigate(['/admin-requests', requestId]);
}
}